import { Typography } from "@circle-react-uikit/Typography";

interface StatItemProps {
  title: string;
  value: number | string;
}

export const StatItem = ({ title, value }: StatItemProps) => (
  <div>
    <Typography.LabelSm color="text-light">{title}</Typography.LabelSm>
    <div className="mt-1 flex items-baseline gap-2">
      <Typography.TitleMd weight="semibold">{value}</Typography.TitleMd>
      <Typography.LabelXs color="text-light">-</Typography.LabelXs>
    </div>
  </div>
);
